// HomeWeb.jsx
import React, { useState, useEffect } from 'react';
import { View, ActivityIndicator, Platform } from 'react-native';
import { useNavigation } from '@react-navigation/native';
import BaseWeb from './components/baseWeb';
import styles from './styles/precificadorWebStyles';
import { useLogScreen } from '../useLogScreen';
export default function webViewSmartPagamentosWeb({ route }) {
    useLogScreen('webViewSmartPagamentos');
    useEffect(() => {
        if (Platform.OS === 'web') {
            setTimeout(() => {
                document.title = 'imoGo | Smart Pagamentos';
            }, 100);
        }
    }, []);
    const { usuario_id, url_assinar } = route.params || {};
    const navigation = useNavigation();

    const [loading, setLoading] = useState(true);

    const renderWebContent = () => (
        <View style={{ flex: 1 }}>
            <iframe
                src={url_assinar}
                title="Smart Pagamentos"
                style={{
                    width: '100%',
                    height: '100vh',
                    border: 'none',
                }}
                onLoad={() => setLoading(false)} // ✅ IMPORTANTE!
            />
        </View>
    );

    return (
        <BaseWeb>
            {() => (
                <>
                    {loading && (
                        <View style={styles.loadingContainer}>
                            <ActivityIndicator size="large" color="#730d83" />
                        </View>
                    )}

                    {Platform.OS === 'web'
                        ? renderWebContent()
                        : (
                            <WebView
                                source={{ uri: url_assinar }}
                                style={styles.webview}
                                onLoadEnd={() => setLoading(false)}
                            />
                        )}
                </>
            )}
        </BaseWeb>
    );
}
